export const getCurrentYear = (): string => new Date().getFullYear().toString();
